import React from 'react';
import { css } from '@bts-web/utils-style-engine';
import { SVGIconType } from '../types';

const RegularReceiveGiveaway: React.FC<SVGIconType> = ({
  color,
  size = 22,
  width,
  height,
  className,
  ...restProps
}) => {
  const wrapperClassName = css({
    color: color || 'neutrals.text_primary',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: width || size,
    height: height || size,
  });

  return (
    <span
      data-testid="icon_receive-giveaway"
      className={
        className ? `${wrapperClassName} ${className}` : wrapperClassName
      }
      data-element="icon"
      aria-label="receive-giveaway icon"
      {...restProps}
    >
      <svg
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        width={`${size}px`}
        height={`${size}px`}
        fill="currentcolor"
      >
        <path d="M7.9937 20.5C8.49525 20.5 8.90187 20.0924 8.9019 19.5895C8.90193 19.0866 8.49536 18.6789 7.9938 18.6789L6.60093 18.6788L14.6953 10.5638C15.05 10.2082 15.05 9.63169 14.6954 9.27607C14.3408 8.92045 13.7658 8.92042 13.4111 9.276L5.31639 17.3913L5.3163 16.0019C5.31626 15.499 4.90964 15.0914 4.40808 15.0914C3.90653 15.0915 3.49997 15.4992 3.5 16.0021L3.50025 19.5893C3.50029 20.0921 3.90684 20.4998 4.40835 20.4998L7.9937 20.5Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.7745 8.96155C19.2816 8.96155 20.5 7.73703 20.5 6.23077C20.5 4.72452 19.2816 3.5 17.7745 3.5C16.2673 3.5 15.0489 4.72452 15.0489 6.23077C15.0489 7.73703 16.2673 8.96155 17.7745 8.96155ZM18.6817 6.23077C18.6817 6.73618 18.2736 7.14243 17.7745 7.14243C17.2753 7.14243 16.8672 6.73618 16.8672 6.23077C16.8672 5.72537 17.2753 5.31911 17.7745 5.31911C18.2736 5.31911 18.6817 5.72537 18.6817 6.23077Z"
        />
      </svg>
    </span>
  );
};

export { RegularReceiveGiveaway };
